import React from 'react';

import IFBakery from './Bakery/IFBakery';
import MMBakery from './Bakery/MMBakery';
import IFBeverages from './Beverages/IFBeverages';
import MMBeverages from './Beverages/MMBeverages';
import IFBuyItAgain from './BuyItAgain/IFBuyItAgain';
import MMBuyItAgain from './BuyItAgain/MMBuyItAgain';
import IFColdPack from './ColdPack/IFColdPack';
import MMColdPack from './ColdPack/MMColdPack';
import IFDairyAndEggs from './DairyAndEggs/IFDairyAndEggs';
import MMDairyAndEggs from './DairyAndEggs/MMDairyAndEggs';
import IFDeli from './Deli/IFDeli';
import MMDeli from './Deli/MMDeli';
import IFFruit from './Fruit/IFFruit';
import MMFruit from './Fruit/MMFruit';
import IFGlutenFree from './GlutenFree/IFGlutenFree';
import MMGlutenFree from './GlutenFree/MMGlutenFree';
import IFHome from './Home/IFHome';
import MMHome from './Home/MMHome';
import IFHousehold from './Household/IFHousehold';
import MMHousehold from './Household/MMHousehold';
import IFMeatAndSeafood from './MeatAndSeafood/IFMeatAndSeafood';
import MMMeatAndSeafood from './MeatAndSeafood/MMMeatAndSeafood';
import IFOurBrands from './OurBrands/IFOurBrands';
import MMOurBrands from './OurBrands/MMOurBrands';
import IFPantry from './Pantry/IFPantry';
import MMPantry from './Pantry/MMPantry';
import IFPets from './Pets/IFPets';
import MMPets from './Pets/MMPets';
import IFPlantBased from './PlantBased/IFPlantBased';
import MMPlantBased from './PlantBased/MMPlantBased';
import IFPreparedFoods from './PreparedFoods/IFPreparedFoods';
import MMPreparedFoods from './PreparedFoods/MMPreparedFoods';
import IFProduce from './Produce/IFProduce';
import MMProduce from './Produce/MMProduce';
import IFSale from './Sale/IFSale';
import MMSale from './Sale/MMSale';
import SavedAndRescued from './SavedAndRescued/SavedAndRescued';
import IFShopBy from './ShopBy/IFShopBy';
import MMShopBy from './ShopBy/MMShopBy';
import IFSnacks from './Snacks/IFSnacks';
import MMSnacks from './Snacks/MMSnacks';
import IFVeggies from './Veggies/IFVeggies';
import MMVeggies from './Veggies/MMVeggies';
import VitaminsAndSupplements from './VitaminsAndSupplements/VitaminsAndSupplements';
import IFWine from './Wine/IFWine';
import MMWine from './Wine/MMWine';

const AisleIcons = {
    IFBakery,
    MMBakery,
    IFBeverages,
    MMBeverages,
    IFBuyItAgain,
    MMBuyItAgain,
    IFColdPack,
    MMColdPack,
    IFDairyAndEggs,
    MMDairyAndEggs,
    IFDeli,
    MMDeli,
    IFFruit,
    MMFruit,
    IFGlutenFree,
    MMGlutenFree,
    IFHome,
    MMHome,
    IFHousehold,
    MMHousehold,
    IFMeatAndSeafood,
    MMMeatAndSeafood,
    IFOurBrands,
    MMOurBrands,
    IFPantry,
    MMPantry,
    IFPlantBased,
    MMPlantBased,
    IFPreparedFoods,
    MMPreparedFoods,
    IFPets,
    MMPets,
    IFProduce,
    MMProduce,
    IFShopBy,
    MMShopBy,
    IFSnacks,
    MMSnacks,
    IFVeggies,
    MMVeggies,
    IFWine,
    MMWine,
    IFSale,
    MMSale,
    SavedAndRescued,
    VitaminsAndSupplements,
};

function AisleIcon({ aisleIconName, ...props }) {
    const AisleIconName = AisleIcons[aisleIconName];
    return <AisleIconName {...props} />;
}

export {
    AisleIcon,
    IFBakery,
    MMBakery,
    IFBeverages,
    MMBeverages,
    IFBuyItAgain,
    MMBuyItAgain,
    IFColdPack,
    MMColdPack,
    IFDairyAndEggs,
    MMDairyAndEggs,
    IFDeli,
    MMDeli,
    IFFruit,
    MMFruit,
    IFGlutenFree,
    MMGlutenFree,
    IFHome,
    MMHome,
    IFHousehold,
    MMHousehold,
    IFMeatAndSeafood,
    MMMeatAndSeafood,
    IFOurBrands,
    MMOurBrands,
    IFPantry,
    MMPantry,
    IFPlantBased,
    MMPlantBased,
    IFPreparedFoods,
    MMPreparedFoods,
    IFPets,
    MMPets,
    IFProduce,
    MMProduce,
    IFShopBy,
    MMShopBy,
    IFSnacks,
    MMSnacks,
    IFVeggies,
    MMVeggies,
    IFWine,
    MMWine,
    IFSale,
    MMSale,
    SavedAndRescued,
    VitaminsAndSupplements,
};
